export interface Package {
  _id?: string;
  priceInUSD?: number;
  priceInQAR?: number;
  numberOfGames?: number;
  createdAt?: Date;
}

export function samplePackages(): Array<Package> {
  return [
    {
      _id: "1",
      priceInUSD: 22.5,
      priceInQAR: 80.2,
      numberOfGames: 300,
      createdAt: new Date(),
    },
    {
      _id: "2",
      priceInUSD: 10.5,
      priceInQAR: 40.2,
      numberOfGames: 100,
      createdAt: new Date(),
    },
  ];
}
